export enum PusherEvent {
    SHIPMENT_UPDATED = 'shipment_updated',
    SHIPMENT_DELETED = 'shipment_deleted',
    LABEL_READY = 'multipleShipmentslabelMerge-ready',
}
